import { render, staticRenderFns } from "./DiscountDetails.vue?vue&type=template&id=5b719679&scoped=true&"
import script from "./DiscountDetails.vue?vue&type=script&lang=js&"
export * from "./DiscountDetails.vue?vue&type=script&lang=js&"
import style0 from "./DiscountDetails.vue?vue&type=style&index=0&id=5b719679&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b719679",
  null
  
)

export default component.exports